import PropTypes from 'prop-types';
import React from 'react';

import {REQUEST_ASSIGNEE_SHAPE, RequestAssignee} from 'requests/RequestConstants';

export default function RequestAssignees({assignees}: {assignees: Array<RequestAssignee>}): JSX.Element {
  const names = assignees.map((assignee) => (assignee.user ? assignee.user.name : assignee.team.name));
  const text = names.join(', ');

  return <div className="u-ellipsis-text">{text}</div>;
}
RequestAssignees.propTypes = {
  assignees: PropTypes.arrayOf(REQUEST_ASSIGNEE_SHAPE.isRequired).isRequired,
};
